import { useEffect, useState } from "react";
import "../Components/Analysis/Analysis.css";
import ListComponent from "../Components/Analysis/ListComponent.js";
import DocumentSide from "../Components/Analysis/DocumentSide.js";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    TC_UPDATED,
} from "../Constants/tcConstants.js";
import axios from 'axios';

export const tabInfo = [
    {
        label: "Key Points", id: 1
    },
    {
        label: "Red Flags", id: 2
    },
    {
        label: "Out of Place", id: 3
    },
    {
        label: "Compare", id: 4
    },
];

let getActiveTab = () => { return 4; }

const Analysis = () => {
    // const location = useLocation();

    const params = useParams();
    const dispatch = useDispatch();

    const { unsaveds } = useSelector((state) => state.tc);
    const { isAuth, user } = useSelector((state) => state.user);

    let text = "default";

    // if (location !== null && location.state !== null) {
    //     text = location.state.text;
    // }

    const [activeTab, setActiveTab] = useState(1);
    const handleTabClick = (id) => {
        setActiveTab(id);
    }
    // eslint-disable-next-line
    useEffect(() => {

        let addr = `api/v1/tcs/full/${params.tcid}`
        //if unsavedId for this tcid exists, then
        if (unsaveds.hasOwnProperty(params.tcid)) {
            addr = `api/v1/tcs/full/${params.tcid}/${unsaveds[params.tcid]}`;
        }

        axios({
            method: 'get',
            url: addr,
            baseURL: '/',
        })
            .then((response) => {
                if (response.data.fullData) {
                    dispatch({ type: TC_UPDATED, payload: response.data.fullData });
                }
            })
            .catch(function (error) {
                if (error.response) {
                    console.log(error.response);
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    console.log("error on frontend");
                }
            });
        // eslint-disable-next-line
    }, [dispatch]);
    //don't have to add dispatch (should be stable (with some edge cases)), but, no harm doing it either, so ye.
    //don't want this to reload when params.tcid or unsaveds changes.

    useEffect(() => {
        if (isAuth && user && user.preferences) {
          const textSize = user.preferences.textSize;
    
          switch (textSize) {
            case 0: // Small
                document.documentElement.style.setProperty('--analysis-font-size-header', '0.8vw');
                document.documentElement.style.setProperty('--analysis-font-size-label', '12px');
                document.documentElement.style.setProperty('--analysis-font-size-button', '0.8vw');
                break;
            case 1: // Medium (default)
                document.documentElement.style.setProperty('--analysis-font-size-header', '1vw');
                document.documentElement.style.setProperty('--analysis-font-size-label', '14px');
                document.documentElement.style.setProperty('--analysis-font-size-button', '1vw');
                break;
            case 2: // Large
                document.documentElement.style.setProperty('--analysis-font-size-header', '1.3vw');
                document.documentElement.style.setProperty('--analysis-font-size-label', '18px');
                document.documentElement.style.setProperty('--analysis-font-size-button', '1.5vw');
                break;
            default:
              break;
          }
        } else if (!isAuth) { 
            document.documentElement.style.setProperty('--analysis-font-size-header', '1vw');
            document.documentElement.style.setProperty('--analysis-font-size-label', '14px');
            document.documentElement.style.setProperty('--analysis-font-size-button', '1vw');
          }
        }, [user, isAuth]);
      
    // useEffect(() => {
    //     if (tc) {
    //         if (tc.analysis){
    //             text = tc.analysis.content;
    //         }
    //     }
    // }, [tc]);

    getActiveTab = () => {
        return activeTab;
    }

    return (
        <div className="analysis">
            <DocumentSide text={text} />
            <div className="results">
                <div className="tabs">
                    <Tab id="keyPointsTab" key={tabInfo[0].id} label={tabInfo[0].label} onClick={() => handleTabClick(tabInfo[0].id)} isActive
                        ={tabInfo[0].id === activeTab} />
                    <Tab id="redFlagsTab" key={tabInfo[1].id} label={tabInfo[1].label} onClick={() => handleTabClick(tabInfo[1].id)} isActive
                        ={tabInfo[1].id === activeTab} />
                    <Tab id="outOfPlaceTab" key={tabInfo[2].id} label={tabInfo[2].label} onClick={() => handleTabClick(tabInfo[2].id)} isActive
                        ={tabInfo[2].id === activeTab} />
                    <Tab id="compareTab" key={tabInfo[3].id} label={tabInfo[3].label} onClick={() => handleTabClick(tabInfo[3].id)} isActive
                        ={tabInfo[3].id === activeTab} />
                </div>

                <div className="tab-content">
                    <ListComponent type={tabInfo[activeTab-1].label} />
                </div>
            </div>
        </div>
    );
}

export const getTab = () => {
    return getActiveTab();
}

const Tab = ({ label, onClick, isActive, id }) => {
    return <div id={id} className={`tab-btn ${isActive ? "active" : ""}`} onClick={onClick}>{label}</div>;
}

export default Analysis;